import { css } from '@microsoft/fast-element';
import { cardStyles } from '../card/card.styles';
import { radioStyles } from '../radio/radio.styles';
import { selectableCardStyles } from '../../styles/patterns/selectable-card';

export const radioCardStyles = css`
    ${cardStyles}
    ${radioStyles}
    ${selectableCardStyles}
`;
